import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';
import LanguageSwitcher from './UI/LanguageSwitcher/LanguageSwitcher';
import authService from './api-authorization/AuthorizeService';

class NavMenuComponent extends Component {
  static displayName = NavMenuComponent.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
      isAdmin: false,
      isManager: false,
      isLoggedIn: false
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.authenticationChanged());
    this.populateAuthenticationState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateAuthenticationState() {
    const user = await authService.getUser();

    const auth = {
      isAdmin: user?.role === "admin",
      isManager: user?.role === "manager",
      isLoggedIn: user?.role != null
    };

    this.setState(auth);
  }

  async authenticationChanged() {
    this.setState({ role: false, isAdmin: false, isManager:false, isLoggedIn: false });
    await this.populateAuthenticationState();
  }

  onChangeLanguage (language) {
    i18n.changeLanguage(language);
  }

  render () {
    const { t } = this.props;

    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
          <Container>
            <NavbarBrand tag={Link} to="/">
              <img src="/calendar.svg" alt="Planner" />
              Planner
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                {this.state.isLoggedIn && <>
                  <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/orders">{t("Orders")}</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/materials">{t("Materials")}</NavLink>
                  </NavItem>
                </>}
                {this.state.isManager && <>
                  <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/archive">{t("Archive")}</NavLink>
                  </NavItem>
                </>}
                {this.state.isAdmin && <>
                  <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/users">{t("Users")}</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="text-dark" to="/offices">{t("Offices")}</NavLink>
                  </NavItem>
                </>}
                <LanguageSwitcher onChange={this.onChangeLanguage} />
                <LoginMenu />
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}

export const NavMenu = withTranslation()(NavMenuComponent)
